module.exports = __webpack_public_path__ + "static/img/7.e63501d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/7.jpg
// module id = QQYA
// module chunks = 26